<template>
  <div>
    <al-apply 
      :applyType="$route.params.applyType"
      :editInfo="params">
    </al-apply>
  </div>
</template>

<script>
import alApply from "@/components/xalApplyFileupload/index";
export default {
  name: "",
  components: {
    alApply
  },
  props: {},
  data() {
    return {
      params: this.$route.params.applyFiles ? this.$route.params : null,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
